import React, {Component} from 'react';
import axios from "axios";
import Button from "react-bootstrap/Button";

import classes from'./NewPlatform.module.css';
import Form from "react-bootstrap/Form";
import apiUrl from "../../../shared/config";

class NewPlatform extends Component  {
    state = {
        game_platforms: [],
        game_platform: {
            game_platform_id: null,
            game_platform_name: '',
            game_platform_short_name: '',
            game_platform_notes: ''
        }
    };

    componentDidMount() {
        if (this.props.game_platforms !== []) {
            this.setState({game_platforms: this.props.game_platforms});
        }
    }

    addHandler = () => {
        this.postDataHandler(null);
        this.props.newGamePlatformToggle();
    };

    postDataHandler = () => {
        const post = {
            "game_platform_id": this.state.game_platform.game_platform_id,
            "game_platform_name": this.state.game_platform.game_platform_name,
            "game_platform_short_name": this.state.game_platform.game_platform_short_name,
            "game_platform_notes": this.state.game_platform.game_platform_notes,
        };
        axios.post(apiUrl +'Platforms/set', post)
            .then(response => {
                this.props.onNewGamePlatform(response.data);
            });
        this.setState({
            "game_platform": {
                game_platform_id: null,
                game_platform_name: '',
                game_platform_short_name: '',
                game_platform_notes: ''
            }
        });

    };

    render() {
        return (
            <>
                <dd className={"col-sm-9"}>
                    <div className={classes.NewGamePlatformsBlock}>
                        <div>
                            <Form.Control
                                type="text"
                                placeholder="Enter the name of the game platform you want to create."
                                value={this.state.game_platform.game_platform_name}
                                onChange={(event) => this.setState({game_platform: {...this.state.game_platform, game_platform_name: event.target.value}})}
                            />
                            <Form.Control
                                type="text"
                                placeholder="Enter the short name of the game platform you want to create."
                                value={this.state.game_platform.game_platform_short_name}
                                onChange={(event) => this.setState({game_platform: {...this.state.game_platform, game_platform_short_name: event.target.value}})}
                            />
                            <Form.Control
                                as="textarea"
                                rows="4"
                                placeholder="Include a paragraph or so long description of the game platform."
                                value={this.state.game_platform.game_platform_notes}
                                onChange={(event) => this.setState({game_platform: {...this.state.game_platform, game_platform_notes: event.target.value}})}
                            />
                        </div>
                        <Button className="col-sm-3" variant="outline-warning" onClick={this.props.newGamePlatformToggle}>Cancel</Button>
                        <Button className="col-sm-3" variant="outline-primary" onClick={
                            this.addHandler
                        }>Submit</Button>
                    </div>
                </dd>
                <dt className="col-sm-3"> </dt>
            </>
        );
    }
}

export default NewPlatform;